import {createContext} from "react";

export const NextWindowContext = createContext<any>(null);